export const WHITE_KING = '&#x2654;';
export const WHITE_QUEEN = '&#x2655;';
export const WHITE_ROOK = '&#x2656;';
export const WHITE_BISHOP = '&#x2657;';
export const WHITE_KNIGHT = '&#x2658;';
export const WHITE_PAWN = '&#x2659;';

export const BLACK_KING = '&#x265A;';
export const BLACK_QUEEN = '&#x265B;';
export const BLACK_ROOK = '&#x265C;';
export const BLACK_BISHOP = '&#x265D;';
export const BLACK_KNIGHT = '&#x265E;';
export const BLACK_PAWN = '&#x265F;';